export const SET_TOAST_NOTIFICATION = 'SET_TOAST_NOTIFICATION';
export const RESET_TOAST_NOTIFICATION = 'RESET_TOAST_NOTIFICATION';